export default {
  SYSTEM_TITLE: 'SYSTEM_TITLE',
	PRICE_ELECTRIC:'PRICE_ELECTRIC',
	PRICE_WATER: 'PRICE_WATER',
	ARREARS_METER_OPEN_CLOSE_SWITCH_METHOD: 'ARREARS_METER_OPEN_CLOSE_SWITCH_METHOD', //电表拉合闸验证方式
	ARREARS_METER_OPEN_CLOSE_SWITCH_PASSWORD_METHOD: '0', //密码
	ARREARS_METER_OPEN_CLOSE_SWITCH_VERIFICATION_CODE_METHOD: '1', //验证码

	ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_METHOD: 'ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_METHOD', //水表拉合闸验证方式
	ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_PASSWORD_METHOD: '0', //密码
	ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_VERIFICATION_CODE_METHOD: '1', //验证码
	PRICE_ELECTRIC_SERVICE_FEE_NAME: 'PRICE_ELECTRIC_SERVICE_FEE_NAME', //电服务费自定义名称
	PRICE_WATER_SERVICE_FEE_NAME: 'PRICE_WATER_SERVICE_FEE_NAME' //水服务费自定义名称
};
